<nav aria-label="breadcrumb"
     class="navbar bg-white">
  <app-related-items-history [history]="relatedItemsHistory | async"
                             (selectedObjectEmitter)="clearHistoryAndHandleSelectedObject($event)"></app-related-items-history>
  <app-breadcrumb [breadcrumbs]="breadcrumbs$ | async"
                  (selectedObjectEmitter)="handleSelectedObject($event)"></app-breadcrumb>
</nav>
<app-object-details *ngIf="urn != null"
                    [objectData]="objectData"
                    [deletable]="canObjectBeDeleted$ | async">
</app-object-details>

<app-related-items [relatedItems]="relatedItems"></app-related-items>

<button *ngIf="projectService.hasProject"
        class="btn btn-send-project btn-block"
        (click)="sendProject()">Invia Progetto</button>

<button *ngIf="projectService.hasProject"
        class="btn btn-delete-project btn-block"
        (click)="deleteProject()">Elimina Progetto</button>

<button *ngIf="templateService.addingTemplate"
        class="btn btn-cancella-template btn-block"
        (click)="cancelTemplate()">Annulla</button>

<button *ngIf="editGeometryService.editingGeometry"
        class="btn btn-send-modifiche btn-block"
        (click)="sendEditGeometry()">Salva Modifiche</button>

<button *ngIf="editGeometryService.editingGeometry"
        class="btn btn-cancella-modifiche btn-block"
        (click)="cancelEditGeometry()">Annulla</button>

<button class="btn border-0 btn-template bg-blu txt-white btnControl"
        (click)="handleOpenTemplatesModal()"
        [disabled]="templateService.addingTemplate || editGeometryService.editingGeometry">
        <fa-icon [icon]="icons.faPlus"></fa-icon>
</button>

<button class="btn border-0 btn-snap bg-blu txt-white btnControl"
        (click)="toggleSnap()"
        [ngClass]="{'bg-blu' : !isSnapActive(), 'bg-blu_pressed': isSnapActive()}"
        [disabled]="!templateService.addingTemplate && !editGeometryService.editingGeometry">
        <fa-icon [icon]="icons.faArrowUpRightFromSquare"></fa-icon>
</button>